import { useEffect, useState } from "react";

import { PlusSmallIcon } from "@heroicons/react/24/outline";

import CheckInStepModal from "../../components/checkIn/CheckInStepModal";
import CheckInStepsTable from "../../components/checkIn/CheckInStepsTable";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useCheckIn from "../../data/useCheckIn";
import { ICheckInStep } from "../../models/CheckIn";

export default function CheckInEditor() {
  const { setInfo } = usePageNameContext();
  const { allCheckInSteps } = useCheckIn(undefined, undefined, true);
  const [checkInSteps, setCheckInSteps] = useState<ICheckInStep[] | undefined>(undefined);
  const [editCheckInStep, setEditCheckInStep] = useState<ICheckInStep | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [createOpen, setCreateOpen] = useState(false);

  useEffect(() => {
    setInfo({
      name: "Check In Editor",
      desc: "View and manage vehicle check-in steps",
    });
  }, [setInfo]);

  useEffect(() => {
    if (!allCheckInSteps.isLoading && allCheckInSteps.data) {
      setCheckInSteps(allCheckInSteps.data?.data);
      setIsLoading(false);
    }
  }, [allCheckInSteps.isLoading, allCheckInSteps.data]);

  const handleSetCheckInStep = (checkInStep: ICheckInStep) => {
    setEditCheckInStep(checkInStep);
    setCreateOpen(true);
  };

  const handleAddCheckInStep = () => {
    setEditCheckInStep(undefined);
    setCreateOpen(true);
  };

  return allCheckInSteps.isLoading || isLoading ? (
    <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
      <LoadingWheel />
    </div>
  ) : (
    <>
      <CheckInStepModal open={createOpen} setOpen={setCreateOpen} checkInStep={editCheckInStep} />
      <div className="mt-4 flex justify-between">
        <button
          className="bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
          type="button"
          onClick={handleAddCheckInStep}
        >
          <PlusSmallIcon className="h-5 w-5 mr-2" />
          Add New Check-In Step
        </button>
      </div>

      <CheckInStepsTable checkInSteps={checkInSteps!} setCheckInStep={handleSetCheckInStep} />
    </>
  );
}
